import { Routes } from "@angular/router";
import { ActiveChatComponent } from "./chat/active-chat/active-chat.component";
import { LandingComponent } from "./chat/landing/landing.component";

export const routes: Routes = [
  { path: "", component: LandingComponent },
  { path: "chat", component: ActiveChatComponent },
];
